module.exports = __webpack_public_path__ + "img/fr.fd850af1.svg";